export const TABLET_MIN_DIM = 720;
export const checkUAMatches = (re) => typeof navigator !== "undefined" && re.test(navigator.userAgent || "");
export const checkHasMatchMedia = () => typeof window !== "undefined" && "matchMedia" in window;
export const checkHasCoarsePointer = () => checkHasMatchMedia() && window.matchMedia("(pointer: coarse)").matches;
export const checkHasTouch = () => typeof navigator !== "undefined" &&
    ((navigator.maxTouchPoints || 0) > 0 ||
        (checkHasMatchMedia() &&
            window.matchMedia("(hover: none) and (pointer: coarse)").matches));
export const minScreenDim = () => {
    if (typeof window === "undefined" || !window.screen) {
        return 0;
    }
    return Math.min(window.screen.width, window.screen.height);
};
export const classifyBySize = () => minScreenDim() >= TABLET_MIN_DIM ? "tablet" : "phone";
export const classifyIOS = () => {
    if (checkUAMatches(/\b(iPhone|iPod)\b/i)) {
        return "phone";
    }
    if (checkHasTouch()) {
        return classifyBySize();
    }
    return "desktop";
};
export const classifyAndroid = (uaDataMobile) => {
    if (uaDataMobile === true) {
        return "phone";
    }
    if (uaDataMobile === false) {
        return "tablet";
    }
    if (checkUAMatches(/Android(?!.*Mobile)/i)) {
        return "tablet";
    }
    if (checkUAMatches(/Android.*Mobile/i)) {
        return "phone";
    }
    if (checkHasTouch()) {
        return classifyBySize();
    }
    return "desktop";
};
export const classifyFallback = () => {
    if (checkHasTouch() &&
        checkHasCoarsePointer() &&
        minScreenDim() >= TABLET_MIN_DIM) {
        return "tablet";
    }
    return "desktop";
};
export const checkIsMobileOS = (OSName) => {
    if (!OSName) {
        return false;
    }
    return ["android", "ios"].includes(OSName?.toLowerCase());
};
export const checkIsAndroid = (OSName) => OSName?.toLowerCase() === "android";
export const checkIsIOS = (OSName) => OSName?.toLowerCase() === "ios";
export const checkIsIPadOS = () => typeof navigator !== "undefined" &&
    navigator.platform === "MacIntel" &&
    navigator.maxTouchPoints > 1;
export const getNavPlatform = () => typeof navigator !== "undefined" && "platform" in navigator
    ? navigator.platform
    : "";
export const detectLinuxOrAndroid = () => {
    const hasMM = checkHasMatchMedia();
    const coarse = hasMM && window.matchMedia("(pointer: coarse)").matches;
    const touch = checkHasTouch();
    if (touch && coarse) {
        return "Android";
    }
    return "Linux";
};
export const detectLinuxPlatform = (ua) => {
    if (/android/i.test(ua)) {
        return "Android";
    }
    if (/cros/i.test(ua)) {
        return "Chrome OS";
    }
    if (navigator.userAgentData?.mobile === true) {
        return "Android";
    }
    if (checkHasTouch()) {
        return "Android";
    }
    return "Linux";
};
export const mapPlatformToOS = (platform) => {
    const platformMap = {
        win: "Windows",
        mac: "macOS",
        android: "Android",
        iphone: "iOS",
        ipad: "iOS",
        cros: "Chrome OS",
        kaios: "Linux",
        harmony: "Android",
        fuchsia: "Linux",
    };
    for (const key in platformMap) {
        if (platform.includes(key)) {
            return platformMap[key];
        }
    }
    return "Unknown";
};
export const detectHighConfidenceOS = (userAgent) => {
    if (checkIsIPadOS()) {
        return "iOS";
    }
    if (/(iPhone|iPad|iPod)/.test(userAgent)) {
        return "iOS";
    }
    if (/Android/i.test(userAgent)) {
        return "Android";
    }
    if (/CrOS/i.test(userAgent)) {
        return "Chrome OS";
    }
    return undefined;
};
export const detectDesktopOS = (userAgent, navPlatform) => {
    if (/Win(dows )?(NT|32|64|CE)?/.test(userAgent) ||
        /Win/.test(navPlatform)) {
        return "Windows";
    }
    if (/Mac(OS)?\s?X?/.test(userAgent) || /Mac/.test(navPlatform)) {
        return "macOS";
    }
    return undefined;
};
